import { createFileRoute } from '@tanstack/react-router';
import { CriteriosPage, lerBuscaCriterios } from '@/components/criterios-rateio';

export const Route = createFileRoute('/_app/custos/criterios')({
  validateSearch: (bruto: Record<string, unknown>) => lerBuscaCriterios(bruto),
  component: CriteriosRota,
});

function CriteriosRota() {
  return <CriteriosPage busca={Route.useSearch()} />;
}
